import Hero from '../../components/landing/Hero';
import Features from '../../components/landing/Features';
import Testimonials from '../../components/landing/Testimonials';
import HowItWorks from '../../components/landing/HowItWorks';
import Pricing from '../../components/landing/Pricing';
import FAQ from '../../components/landing/FAQ';
import Download from '../../components/landing/Download';
import SEO from '../../components/common/SEO';

export default function Landing() {
  return (
    <>
      <SEO page="home" />
      <div>
        <Hero />
        <Features />
        <Testimonials />
        <HowItWorks />
        <Pricing />
        <FAQ />
        <Download />
      </div>
    </>
  );
}
